/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { GraphicalTakeOffTopDto, GraphicalTakeOffTopViewDto } from './dto';

export const GraphicalTakeOffTopMapper = entity<GraphicalTakeOffTopDto>();
export const GraphicalTakeOffTopViewMapper = entity<GraphicalTakeOffTopViewDto>();
